<template>
  <header class="header">
    <div class="header-inner">
      <div class="header-left">
        <div class="brand" @click="goHome">
          <div class="brand-logo">T</div>

          <div class="brand-text">
            <div class="brand-title">Auto test</div>
            <div class="brand-subtitle">e-solution.uz</div>
          </div>
        </div>
      </div>

      <div class="header-center">
        <div class="payment-pill" :class="paymentStatusClass">
          <span class="payment-dot"></span>
          <span class="payment-label">{{ paymentLabel }}</span>
        </div>
      </div>

      <div class="header-right">
        
        <a-dropdown placement="bottomRight" trigger="click">
          <button class="user-trigger" type="button">
            <div class="user-avatar">{{ userInitial }}</div>

            <div class="user-meta">
              <div class="user-name">{{ userName }}</div>
              <div class="user-phone">{{ userPhone }}</div>
            </div>

            <span class="user-caret">⌄</span>
          </button>

          <template #overlay>
            <div class="menu-shell">
              <a-menu class="user-menu">
                <a-menu-item key="profile" disabled>
                  <div class="menu-profile">
                    <div class="menu-avatar">{{ userInitial }}</div>
                    <div class="menu-meta">
                      <div class="menu-name">{{ userName }}</div>
                      <div class="menu-phone">{{ userPhone }}</div>
                    </div>
                  </div>
                </a-menu-item>

                <a-menu-divider />

                <a-menu-item key="home" @click="goHome">
                  <span class="menu-row-icon">🏠</span>
                  <span>Bosh sahifa</span>
                </a-menu-item>

                <a-menu-item key="theme" @click="toggleTheme">
                  <span class="menu-row-icon">{{ theme === 'dark' ? '☀️' : '🌙' }}</span>
                  <span>{{ theme === 'dark' ? 'Light mode yoqish' : 'Dark mode yoqish' }}</span>
                </a-menu-item>

                <a-menu-divider />

                <a-menu-item key="logout" danger @click="showLogoutConfirm = true">
                  <span class="menu-row-icon">⎋</span>
                  <span>Chiqish</span>
                </a-menu-item>
              </a-menu>
            </div>
          </template>
        </a-dropdown>
      </div>
    </div>

    <a-modal
      v-model:open="showLogoutConfirm"
      title="Tizimdan chiqish"
      ok-text="Ha, chiqaman"
      cancel-text="Bekor qilish"
      @ok="confirmLogout"
    >
      <p>Rostdan ham tizimdan chiqmoqchimisiz?</p>
    </a-modal>
  </header>
</template>

<script>
export default {
  data() {
    return {
      showLogoutConfirm: false
    }
  },

  computed: {
    theme() {
      return this.$store.getters.currentTheme
    },

    user() {
      return this.$store.state.auth.user || {}
    },

    userName() {
      return this.user.name || 'Foydalanuvchi'
    },

    userPhone() {
      return this.user.phone || '+998'
    },

    userInitial() {
      return this.userName?.charAt(0)?.toUpperCase() || 'U'
    },

    // Store ichida payment_due_date bo'lsa shundan oladi.
    // Masalan: '2026-03-30'
    paymentDueDate() {
      return this.$store.state.auth?.user?.payment_due_date || this.$store.state.paymentDueDate || null
    },

    daysLeft() {
      if (!this.paymentDueDate) return null

      const today = new Date()
      const current = new Date(today.getFullYear(), today.getMonth(), today.getDate())

      const due = new Date(this.paymentDueDate)
      const dueDate = new Date(due.getFullYear(), due.getMonth(), due.getDate())

      const diff = dueDate - current
      return Math.ceil(diff / (1000 * 60 * 60 * 24))
    },

    paymentLabel() {
      if (this.daysLeft === null) return 'To‘lov muddati kiritilmagan'
      if (this.daysLeft < 0) return `To‘lov muddati o‘tgan`
      if (this.daysLeft === 0) return `Bugun to‘lov kuni`
      if (this.daysLeft === 1) return `To‘lovgacha 1 kun qoldi`
      return `To‘lovgacha ${this.daysLeft} kun qoldi`
    },

    paymentStatusClass() {
      if (this.daysLeft === null) return 'is-neutral'
      if (this.daysLeft < 0) return 'is-danger'
      if (this.daysLeft <= 3) return 'is-warning'
      return 'is-good'
    }
  },

  methods: {
    toggleTheme() {
      this.$store.dispatch('toggleTheme')
    },

    goHome() {
      this.$router.push('/')
    },

    confirmLogout() {
      this.showLogoutConfirm = false
      this.$store.dispatch('logout')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>

.header-inner {
  max-width: 1680px;
  margin: 0 auto;
  height: 72px;
  padding: 0 24px;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 18px;
}

.header-left {
  min-width: 0;
}

.header-center {
  display: flex;
  justify-content: center;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  user-select: none;
}

.brand-logo {
  width: 42px;
  height: 42px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  font-size: 18px;
  color: white;
  background: linear-gradient(135deg, var(--primary), var(--primary-soft));
  box-shadow: 0 10px 22px rgba(37, 99, 235, 0.28);
  flex-shrink: 0;
}

.brand-text {
  min-width: 0;
}

.brand-title {
  font-size: 18px;
  line-height: 1.1;
  font-weight: 800;
  color: var(--text);
  letter-spacing: 0.2px;
}

.brand-subtitle {
  margin-top: 3px;
  font-size: 12px;
  color: var(--text-soft);
}

.payment-pill {
  min-height: 40px;
  padding: 0 16px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border: 1px solid var(--border);
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
  box-shadow: 0 6px 18px rgba(0,0,0,0.06);
}

.payment-dot {
  width: 9px;
  height: 9px;
  border-radius: 999px;
  flex-shrink: 0;
}

.payment-pill.is-good {
  color: #22c55e;
  background: rgba(34, 197, 94, 0.08);
  border-color: rgba(34, 197, 94, 0.22);
}

.payment-pill.is-good .payment-dot {
  background: #22c55e;
  box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.14);
}

.payment-pill.is-warning {
  color: #f59e0b;
  background: rgba(245, 158, 11, 0.08);
  border-color: rgba(245, 158, 11, 0.22);
}

.payment-pill.is-warning .payment-dot {
  background: #f59e0b;
  box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.14);
}

.payment-pill.is-danger {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.08);
  border-color: rgba(239, 68, 68, 0.22);
}

.payment-pill.is-danger .payment-dot {
  background: #ef4444;
  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.14);
}

.payment-pill.is-neutral {
  color: var(--text-soft);
  background: rgba(148, 163, 184, 0.08);
  border-color: rgba(148, 163, 184, 0.18);
}

.payment-pill.is-neutral .payment-dot {
  background: #94a3b8;
  box-shadow: 0 0 0 4px rgba(148, 163, 184, 0.12);
}

.theme-btn,
.user-trigger {
  border: 1px solid var(--border);
  background: rgba(255,255,255,0.04);
  color: var(--text);
}

:global([data-theme='light']) .theme-btn,
:global([data-theme='light']) .user-trigger {
  background: rgba(255,255,255,0.78);
}

.theme-btn {
  height: 42px;
  padding: 0 14px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: 0.2s ease;
  font: inherit;
}

.theme-btn:hover,
.user-trigger:hover {
  transform: translateY(-1px);
  border-color: rgba(59,130,246,0.28);
  background: rgba(59,130,246,0.08);
}

.theme-icon {
  font-size: 15px;
  line-height: 1;
}

.theme-text {
  font-size: 13px;
  font-weight: 700;
}

.user-trigger {
  min-height: 44px;
  padding: 5px 10px 5px 6px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: 0.2s ease;
  font: inherit;
}

.user-avatar {
  width: 34px;
  height: 34px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  color: #fff;
  background: linear-gradient(135deg, var(--primary), var(--primary-soft));
  flex-shrink: 0;
}

.user-meta {
  line-height: 1.1;
  text-align: left;
}

.user-name {
  font-size: 13px;
  font-weight: 700;
  color: var(--text);
  white-space: nowrap;
}

.user-phone {
  margin-top: 3px;
  font-size: 11px;
  color: var(--text-soft);
  white-space: nowrap;
}

.user-caret {
  color: var(--text-soft);
  font-size: 14px;
}

.menu-shell {
  overflow: hidden;
  border-radius: 16px;
  border: 1px solid var(--border);
  box-shadow: 0 18px 40px rgba(0,0,0,0.16);
}

.menu-profile {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 2px 0;
}

.menu-avatar {
  width: 34px;
  height: 34px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  color: #fff;
  background: linear-gradient(135deg, var(--primary), var(--primary-soft));
}

.menu-meta {
  min-width: 0;
}

.menu-name {
  font-weight: 700;
  color: var(--text);
}

.menu-phone {
  font-size: 12px;
  color: var(--text-soft);
}

.menu-row-icon {
  display: inline-flex;
  width: 18px;
  justify-content: center;
  margin-right: 8px;
}

:deep(.ant-dropdown-menu) {
  padding: 8px;
  border-radius: 16px;
  background: rgba(16, 24, 40, 0.96);
}

:global([data-theme='light']) :deep(.ant-dropdown-menu) {
  background: rgba(255,255,255,0.98);
}

:deep(.ant-dropdown-menu-item) {
  min-height: 40px;
  display: flex;
  align-items: center;
  border-radius: 10px;
  margin: 2px 0;
  color: var(--text);
}

:deep(.ant-dropdown-menu-item:hover) {
  background: rgba(59,130,246,0.08);
}

:deep(.ant-dropdown-menu-item-disabled) {
  opacity: 1;
  cursor: default;
}

:deep(.ant-dropdown-menu-item-divider) {
  margin: 8px 0;
  background: var(--border);
}

:deep(.ant-modal-content) {
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid var(--border);
  background: rgba(16, 24, 40, 0.98);
}

:global([data-theme='light']) :deep(.ant-modal-content) {
  background: rgba(255,255,255,0.99);
}

:deep(.ant-modal-header) {
  background: transparent;
  border-bottom: 1px solid var(--border);
}

:deep(.ant-modal-title) {
  color: var(--text);
  font-weight: 800;
}

:deep(.ant-modal-body) {
  color: var(--text-soft);
}

:deep(.ant-modal-footer) {
  border-top: 1px solid var(--border);
}

@media (max-width: 1100px) {
  .header-inner {
    grid-template-columns: auto auto;
  }

  .header-center {
    display: none;
  }
}

@media (max-width: 768px) {
  .header-inner {
    height: 64px;
    padding: 0 14px;
    gap: 10px;
  }

  .brand-subtitle,
  .theme-text,
  .user-phone,
  .user-caret {
    display: none;
  }

  .brand-title {
    font-size: 16px;
  }

  .user-meta {
    display: none;
  }

  .theme-btn {
    padding: 0 10px;
  }

  .brand-logo {
    width: 38px;
    height: 38px;
    border-radius: 12px;
  }
}

@media (max-width: 520px) {
  .header-inner {
    padding: 0 12px;
  }

  .brand-text {
    max-width: 110px;
  }

  .brand-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>